/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import 'components/util/dynamic-sticky/dynamic-sticky';

import SearchLinkController from 'controllers/search-link-controller';
EezyStimulusApplication.register('search-link', SearchLinkController);

import DynamicStickyController from 'components/util/dynamic-sticky/dynamic-sticky-controller';
EezyStimulusApplication.register('dynamic-sticky', DynamicStickyController);
